export const isSuperAdministratorRole = (role?: string | null) =>
  role?.toLowerCase() === "super administrator"
